<section class="scene-selector">
  <div class="header">
    <div class="scene-window-header">
      <p class="scene-window-label">{{ label }}</p>
      <div class="scene-window-actions">
        <ng-content></ng-content>
      </div>
    </div>
    <div class="export-button">
      <app-rfebm-primary-button size="small">
        Exportar en
      </app-rfebm-primary-button>
    </div>
  </div>

  <div
    class="scene-card-list-container"
    [ngClass]="{ hidden: isCollapsed, visible: !isCollapsed }"
  >
    @if (scenes) {
    <!-- Actual Scenes -->
    @for (scene of scenes; track $index) {
    <app-scene-card
      [scene]="scene"
      [videoPlayer]="videoPlayer"
      (onSceneSelected)="sceneSelected($event)"
    ></app-scene-card>
    <div style="height: 10px"></div>
    }
    <!-- Placeholder for empty state -->
    } @else {
    <!--  -->
    @for (scene of skeletonScenes; track $index) {
    <app-scene-card
      [scene]="scene"
      [videoPlayer]="videoPlayer"
    ></app-scene-card>
    <div style="height: 10px"></div>
    } }
  </div>
</section>
